"use strict";

var e = require("../loading-cf343785.js");
require("../extends-fa579b0f.js"), require("../_commonjsHelpers-f10b257f.js"), require("react"), require("classnames"), require("prop-types"), require("../taggedTemplateLiteral-97b463ad.js"), require("styled-components"), require("polished/lib/helpers/rem"), module.exports = e.LoadingComponent;